module.exports = __webpack_public_path__ + "static/media/phoneIcon.e3ca9950.svg";